import React from 'react';
import styled from 'styled-components';

import { useLexicon } from '../../hooks/useLexicon';

const PlayerMatchesFilterBar = ({
  seasons = [],
  selectedSeasonId,
  onSeasonChange,
  competitions = [],
  selectedCompetitionId,
  onCompetitionChange,
}) => {
  const l = useLexicon();
  if (seasons.length <= 1 && competitions.length <= 1) return null;

  return (
    <Bar>
      {seasons.length > 1 && (
        <Select
          value={selectedSeasonId ?? ''}
          onChange={(e) => onSeasonChange?.(e.target.value)}
          aria-label={l(453)}
        >
          {seasons.map((season) => (
            <option key={season.id} value={season.id}>
              {season.years ?? season.name ?? season.id}
            </option>
          ))}
        </Select>
      )}

      {competitions.length > 1 && (
        <Select
          value={selectedCompetitionId ?? ''}
          onChange={(e) => onCompetitionChange?.(e.target.value)}
          aria-label={l(454)}
        >
          <option value="">{l(1704)}</option>
          {competitions.map((c) => (
            <option key={c.id} value={c.id}>
              {c.name}
            </option>
          ))}
        </Select>
      )}
    </Bar>
  );
};

export default PlayerMatchesFilterBar;

const Bar = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

const Select = styled.select`
  flex: 1;
  min-width: 140px;
  padding: 10px 12px;
  border: 1px solid ${(props) => props.theme.borderColor};
  background: ${(props) => props.theme.sidebar};
  color: ${(props) => props.theme.white};
  border-radius: 8px;
  font-family: 'SatoshiMedium', sans-serif;
  font-size: 13px;
`;
